// extracted by mini-css-extract-plugin
module.exports = {"settlement_info":"style_settlement_info__2AlgV"};